import { PersonalParamsDTO } from 'src/app/shared/interfaces/me/personal-params-dto.interface';

export class PersonalParamsParams {
  public name?: string;
  public description?: string;
  public value?: string;
  public shared?: boolean;
  public displayOrder?: number;
  public hideInDashboard?: boolean;
}

export class PersonalParams {
  public id: number;
  public name: string;
  public description: string;
  public value: string;
  public shared: boolean;
  public displayOrder: number;
  public hideInDashboard: boolean;
  constructor(data: PersonalParamsDTO) {
    Object.assign(this, data);
  }
}

export class ListOfAdvancedSearchsDisplayTable extends PersonalParams {
  buttonDelete: string;
  buttonEdit: string;
  buttonUse: string;
}
